import { Col, Text } from 'components';
import { Api } from 'lib';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const BoxContainer = styled.div`
  margin: ${(props) => (props.idx % 4 !== 0 ? '0 0 32px 32px' : '0 0 32px')};

  @media (max-width: 1024px) {
    margin: 0;
  }
`;

const Articles = (props) => {
  const [loadingButton, setLoadingButton] = useState(null),
    isMobile = useSelector((state) => state.appState.isMobile),
    news = useSelector((state) => state.news),
    navigate = useNavigate(),
    dispatch = useDispatch();

  async function removeArticle(id) {
    setLoadingButton(id);
    const res = await Api.post(`/admin/removeData`, { type: 'NewsArticle', id });
    setLoadingButton(null);
    if (!res) return;

    dispatch({
      type: 'REMOVE_ARTICLE',
      payload: id
    });
  }

  return (
    <Col center>
      <Text h4>Under development</Text>
    </Col>
  );
};

export default Articles;

// <ContentContainer>
//   <div className='container'>
//     {!isMobile && (
//       <Col noFlex marg='16px 0 0'>
//         <Button
//           icon='add'
//           text='Add article'
//           wid='150px'
//           onClick={() => navigate('add-article')}
//         />
//       </Col>
//     )}
//
//     <Text h2 marg={isMobile ? '30px 16px 20px' : '30px 0 20px'} >
//       News
//     </Text>
//
//     <div className='wrapped-area'>
//       {news.map((x, i) => (
//         <BoxContainer idx={i} >
//           <NewsBox item={x} i={i} key={i} mobileImageless />
//
//           {!isMobile && (
//             <Row marg='10px 0' between>
//               {loadingButton === x._id ? (
//                 <Col centerAll wid='80px' noFlex>
//                   <Spinner2 spinnerSize='16px'/>
//                 </Col>
//               ) : (
//                 <Button
//                   onClick={() => removeArticle(x._id)}
//                   textButton
//                   text='Remove'
//                   icon='close'
//                   iconCol='red'
//                   textCol='red'
//                 />
//               )}
//
//               <Button
//                 onClick={() => navigate(`/admin/articles/edit/${x._id}`, { state: x })}
//                 textButton
//                 text='Edit'
//                 icon='edit'
//                 textCol={theme.DARK_BLUE}
//                 icnCol={theme.DARK_BLUE}
//               />
//             </Row>
//           )}
//         </BoxContainer>
//       ))}
//     </div>
//   </div>
// </ContentContainer>
